// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BackgroundImage_background__4rSaK .BackgroundImage_background-image__4GmtM {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: 0;
}
.BackgroundImage_background__4rSaK .BackgroundImage_black-filter__0jGt7 {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 0;
}
@media only screen and (max-width: 480px) {
  .BackgroundImage_background__4rSaK {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/InstitutionDetail/Components/BackgroundImage/BackgroundImage.module.scss"],"names":[],"mappings":"AAGE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,UAAA;AAFJ;AAIE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,oCAAA;EACA,UAAA;AAFJ;AAIE;EAtBF;IAuBI,aAAA;EADF;AACF","sourcesContent":[".background {\n  // height: calc(100vh - var(--navbar-height));\n  // width: 100%;\n  .background-image {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n    z-index: 0;\n  }\n  .black-filter {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-color: rgba($color: #000000, $alpha: 0.5);\n    z-index: 0;\n  }\n  @media only screen and (max-width: 480px) {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `BackgroundImage_background__4rSaK`,
	"background-image": `BackgroundImage_background-image__4GmtM`,
	"black-filter": `BackgroundImage_black-filter__0jGt7`
};
export default ___CSS_LOADER_EXPORT___;
